/**
 * 按中文或分号换行处理字符串
 * @param {string} str - 需要处理的原始字符串
 * @returns {string} 处理后带换行符的字符串
 */
import baseData from '@/api/base.js';

export const formatTextWithLineBreak = (str) => {
  console.log(str)
  if (!str) return ''; // 处理空字符串情况
  // 正则：匹配中文（[\u4e00-\u9fa5]）或分号（;），在其后添加换行符
  let temp = '<br>' + str.replace(/\n/g, '<br>')
  console.log(temp)
  return temp;
};
/**
 * 全部图片路径分解为el-upload的fileList
 * @param {object} allImageUrls  全部图片路径
 */
export const handleImgUrl = (allImageUrls) => {
  if (!allImageUrls) return
  return allImageUrls.map(url => {
    // 从完整URL中提取相对路径（用于后端交互）
    const relativePath = url.replace(baseData.IMG_GET_URL, "");
    // 提取文件名（用于展示）
    const fileName = relativePath.split("/").pop() || "未知图片";
    let res = {
      name: fileName,  // 显示的文件名
      url: url,        // 完整URL（用于预览）
      uid: url,        // 唯一标识（用URL避免重复）
      relativePath: relativePath  // 存储相对路径（用于删除/提交）
    }
    return res
  });
}
/**
 * 将表格数据中的图片路径进行分割
 * @param {object} tableData 
 * urlFieldName表示图片路径的属性名
 */
export const sliceImgUrl = (tableData,urlFieldName='imageUrl') => {
  tableData.forEach(row => {
    sliceImgUrlRow(row,urlFieldName)
  })
}
/**
 * 输入数据如果包含imageUrl，将其根据星号进行拆分
 * @param {object} row 
 */
export const sliceImgUrlRow=(row,urlFieldName='imageUrl')=>{
   const imageUrls = row[urlFieldName] ? row[urlFieldName].split('*') : [];
    row.coverUrl = imageUrls[0] || '';
    row.allImageUrls = imageUrls;
  
}

//发请求获取分页数据
export const loadPageData = async(vueInstance,url)=>{
  const res = await vueInstance.$http.get(url)
  return res.data
}
